<template>
  <div>
    <SearchToolbar
      class="mb-6"
      :placeholder="$t('Rechercher par nom, prénom ou email du client')"
      :initial-keywords="keywords"
      @update-keyword-search="updateKeywordSearch"
    />
    <Table :columns="columns" :data="formattedData" :isLoading="isLoading" :noDataMsg="noDataMsg" />
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { Pagination, SearchToolbar, Table } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { Pagination, SearchToolbar, Table },
  props: {
    status: {
      type: String,
      default: null,
    },
    noDataMsg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentPage: 1,
      keywords: null,
    };
  },
  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapGetters("leads", ["getIndex", "isLoading"]),
    leads() {
      return this.getIndex.leads || [];
    },
    totalCount() {
      return this.getIndex.page?.totalCount || 0;
    },
    totalPages() {
      return this.getIndex.page?.totalPages || 0;
    },
    formattedData() {
      return this.leads.map((lead) => ({
        purchaseDate: lead.purchaseDate,
        customerFullName: `${lead.customer.firstName} ${lead.customer.lastName}`,
        customerEmail: lead.customer.email,
        categoryLabel: this.$t(`contract_distributions.category.${lead.categoryId}`),
      }));
    },
    columns() {
      const res = [
        { label: this.$t("LeadsList.Date"), field: "purchaseDate" },
        { label: this.$t("LeadsList.Client"), field: "customerFullName" },
        { label: this.$t("LeadsList.Email"), field: "customerEmail" },
        { label: this.$t("LeadsList.Category"), field: "categoryLabel" },
      ];
      return res;
    },
  },
  created() {
    this.getLeads();
  },
  methods: {
    ...mapActions("leads", ["fetchIndex"]),
    updateKeywordSearch(keywords) {
      this.keywords = keywords;
      this.currentPage = 1;
      this.getLeads();
    },
    handleChangePage(page) {
      this.currentPage = page;
      this.getLeads();
    },
    async getLeads() {
      const params = {
        page: this.currentPage,
        type: ["lead"],
        status: [this.status],
        keywords: this.keywords,
        store: [this.selectedStoreId],
      };
      await this.fetchIndex(params);
    },
  },
};
</script>
